import './index.scss'
$("header .nav ul li").eq(3).addClass("active");